exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.body-box {\n  border-radius: 4px;\n}\n.logOut-btn {\n  width: 210px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #ffffff;\n  border: solid 1px #000000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e2d872ca","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/selectStore.vue
// module id = 346
// module chunks = 1